import apiClient from "../apiClient";

// const baseURLs = {
//   1: "https://211-185-142-193.nip.io/api/", // 정선 동강지중화 현장
//   2: "http://192.168.0.2:8083/api/", // 포스코타워 송도 현장
//   3: "", // 남구현장
//   4: "https://112-168-182-224.nip.io/api/", // 신기흥 분기 1차 (용인-화성)
//   5: "", // 광명 구름산지구 지중화 현장
//   6: "https://---.nip.io/api/", // 신시흥-신송도 2차 (시흥-인천)
// };

// 이 구분은 t_camera_info 테이블의 server_ip_port 컬럼으로 case 나눈거임
const baseURLs = {
  1: {
    // 정선
    "211.185.142.193": "https://211-185-142-193.nip.io/api/",
  },
  2: {
    // 포스코타워
    "192.168.0.2": "http://192.168.0.2:8083/api/",
  },
  4: {
    // 신기흥
    "112.168.182.224": "https://112-168-182-224.nip.io/api/",
  },
  5: {
    // 광명 구름산지구 지중화 현장 // 임의로 해놓은거임
    "9.10.11.12": "http://192.168.0.2:8084/api/",
    "13.14.15.16": "http://192.168.0.2:8085/api/",
  },
  6: {
    // 신시흥-신송도 2차 (시흥-인천) // 임의로 해놓은거임
    "119.197.194.106": "https://119-197-194-106.nip.io/api/",
    "5.6.7.8": "http://192.168.0.2:8082/api/",
  },
};

function getWorkplaceId() {
  return localStorage.getItem("selectedWorkplaceId") || "1";
}

// function createInstance(url = "") {
//   const workplaceId = getWorkplaceId();
//   //alert(workplaceId);
//   const baseURL = baseURLs[workplaceId] || baseURLs["1"];

//   return apiClient.create({
//     baseURL: `${baseURL}${url}`,
//   });
// }

export function createInstance(subKey = null, url = "") {
  const workplaceId = getWorkplaceId();
  const sites = baseURLs[workplaceId];

  const baseURL = (subKey && sites[subKey]) || Object.values(sites)[0]; // ex) 정선이면 "https://211-185-..." 이 나옴
  console.log("★★★★★★★=====" + Object.values(sites)[0]);
  return apiClient.create({
    baseURL: `${baseURL}${url}`,
  });
}

export const instance = createInstance();
